import { useCallback, useEffect, useState } from 'react';
import { CustomButton } from '../../../../components/CustomButton';
import RModal from '../../../../components/Rsuite/Modal';
import { useAuth } from '../../../../hooks/auth';
import { toastSuccess, toastError } from '../../../../toasts';
import api from '../../../../services/api';
import { Spacer } from '../../../../components/Spacer';
import * as S from '../styles';
import { Label } from '../../../../components/Label';
import { CustomCheckPicker } from '../../../../components/CustomCheckPicker';
import { dataDays } from '../../../../constants/dataDays';
import { daysLabels } from '../../../../constants/daysLabels';
import { CustomInput } from '../../../../components/CustomInput';
import { Toggle } from 'rsuite';

const CreateEditBairroHorario = ({
  open,
  onClose,
  neighborhood,
  schedule,
  setSchedules,
}) => {
  const { id_empresa } = useAuth();
  const [selecteds, setSelecteds] = useState([]);
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  const [status, setStatus] = useState(false);

  const validateFields = () => {
    if (!neighborhood && (!Array.isArray(selecteds) || selecteds.length < 1)) {
      throw new Error('Selecione dias para criar horários');
    }

    if (typeof start !== 'string' || start.length < 5) {
      throw new Error('Selecione a hora de início');
    }

    if (typeof start !== 'string' || end.length < 5) {
      throw new Error('Selecione a hora de termino');
    }
  };

  const createSchedules = useCallback(async () => {
    try {
      validateFields();

      const form = selecteds.map((day) => ({
        IdEmpresa: id_empresa,
        IdBairro: neighborhood.Id,
        Dia: day,
        Inicio: start,
        Fim: end,
      }));

      await api
        .post(`horarios-bairro/criar-muitos`, form)
        .then((result) => {
          setSchedules((state) => [...state, ...result.data]);
          toastSuccess('Horários foram salvos');
          onClose();
        })
        .catch((error) => {
          toastError(
            error.response?.data?.message || 'Não foi possivel criar horários',
          );
        });
    } catch (error) {
      const errorMessage = error?.message || 'Não foi possivel criar horários';
      toastError(errorMessage);
    }
  }, [selecteds, start, end]);

  const editSchedule = useCallback(async () => {
    try {
      validateFields();

      const form = {
        Inicio: start,
        Fim: end,
        Ativo: status,
      };

      const result = await api.patch(`horarios-bairro/${schedule.Id}`, form);

      setSchedules((state) =>
        state.map((e) => {
          if (e.Id !== result.data.Id) {
            return e;
          }
          e = result.data;
          return e;
        }),
      );
      toastSuccess('Horário foi salvo');
      onClose();
    } catch (error) {
      const errorMessage = error?.message || 'Não foi possivel edirar horário';
      toastError(errorMessage);
    }
  }, [start, end, status]);

  const handleSubmit = async () => {
    if (schedule) {
      editSchedule();
      return;
    }
    createSchedules();
  };

  useEffect(() => {
    if (schedule) {
      setStart(schedule.Inicio);
      setEnd(schedule.Fim);
      setStatus(schedule.Ativo);
    }
  }, [open]);

  return (
    <RModal
      open={open}
      onClose={onClose}
      title={schedule ? 'Editar Horário' : 'Cadastrar Horário'}
      footer={
        <>
          <CustomButton appearance="default" onClick={onClose}>
            Cancelar
          </CustomButton>
          <CustomButton onClick={handleSubmit}>Salvar</CustomButton>
        </>
      }
    >
      {!schedule && (
        <S.Column>
          <Label>Dia(s)</Label>
          <CustomCheckPicker
            data={dataDays}
            searchable={false}
            onChange={setSelecteds}
            style={{ width: 350 }}
          />
        </S.Column>
      )}

      {schedule && (
        <S.Column>
          <S.Title>{daysLabels[schedule.Dia]}</S.Title>
        </S.Column>
      )}

      <Spacer y={10} />
      <S.Row>
        <S.Column>
          <Label>Início</Label>
          <CustomInput
            type="time"
            onChange={setStart}
            defaultValue={schedule?.Inicio}
          />
        </S.Column>
        <S.Column>
          <Label>Fim</Label>
          <CustomInput
            type="time"
            onChange={setEnd}
            defaultValue={schedule?.Fim}
          />
        </S.Column>
      </S.Row>
      <Spacer y={10} />
      {schedule && (
        <S.Row>
          <Toggle
            checked={status}
            onChange={() => setStatus(!status)}
            checkedChildren="Ativo"
            unCheckedChildren="Inativo"
          />
        </S.Row>
      )}
    </RModal>
  );
};

export default CreateEditBairroHorario;
